// src/sot/primitives/SettingsToggleRow.jsx
import React from "react";
import Divider from "@/components/ui/Divider.jsx";

/**
 * SettingsToggleRow
 *
 * 72-ish px high row for settings cards:
 *  - Title:  text-body-large text-on-surface
 *  - Support: text-body-medium text-on-surface-var
 *  - Optional leading icon, trailing control (Switch / "Change" / chevron)
 *  - Optional inset divider
 *
 * Width and background are controlled by the parent card.
 */
export default function SettingsToggleRow({
  title,
  support,
  trailing = null,
  divider = true,
}) {
  return (
    <>
      <div className="flex items-center justify-between px-4 py-4">
        <div className="flex flex-col min-w-0">
          <span className="text-body-large text-on-surface truncate">
            {title}
          </span>
          {support && (
            <span className="text-body-medium text-on-surface-var truncate">
              {support}
            </span>
          )}
        </div>

        {trailing && (
          <div className="ml-3 shrink-0 flex items-center justify-center">
            {trailing}
          </div>
        )}
      </div>

      {divider && <Divider className="ml-4" />}
      {/* ml-4 = aligned with text on the left, full-bleed on the right */}
    </>
  );
}